import React, { useState } from "react"
import "./StandardButton.scss"
import cn from "classnames"
import SpinnerContainer from "../load/SpinnerContainer"

interface IStandardButtonProps {
  className?: string
  innerClassName?: string
  title: string
  disabled?: boolean
  onClick: () => Promise<void> | void
  forceIsLoading?: boolean

  isBlue?: boolean
  isRed?: boolean
  isOrange?: boolean
  isSmall?: boolean
  width?: number
}

export function StandardButton({
  className,
  innerClassName,
  title,
  onClick,
  disabled,
  isBlue,
  isRed,
  isOrange,
  isSmall,
  forceIsLoading,
  width,
}: IStandardButtonProps) {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <SpinnerContainer
      className={className}
      style={{ width: width + "px" }}
      showSpinner={isLoading || !!forceIsLoading}
    >
      <div
        className={cn(
          "standard-button",
          {
            "standard-button--disabled": disabled,
            "standard-button--blue": isBlue,
            "standard-button--red": isRed,
            "standard-button--orange": isOrange,
            "standard-button--small": isSmall,
          },
          innerClassName
        )}
        onClick={async () => {
          if (disabled) {
            return
          }
          setIsLoading(true)
          try {
            await onClick()
          } finally {
            setIsLoading(false)
          }
        }}
      >
        {title}
      </div>
    </SpinnerContainer>
  )
}
